import { render, staticRenderFns } from "./DepositRequests.vue?vue&type=template&id=2888fa39&scoped=true&"
import script from "./DepositRequests.vue?vue&type=script&lang=js&"
export * from "./DepositRequests.vue?vue&type=script&lang=js&"
import style0 from "./DepositRequests.vue?vue&type=style&index=0&id=2888fa39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2888fa39",
  null
  
)

export default component.exports